// Temporary migration page - can be removed after migration is complete
import React from 'react';
import ImageMigrationRunner from '../components/admin/ImageMigrationRunner';

function Migration() {
  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-6xl mx-auto">
        <ImageMigrationRunner />
      </div>
    </div>
  );
}

export default Migration;